import { Link } from "@inertiajs/react";
import AuditsEmptyState from "@/components/audits/AuditsEmptyState";
import AuditsList from "@/components/audits/AuditsList";
import AuditsPagination from "@/components/audits/AuditsPagination";
import Layout from "@/components/Layout";
import type { AuditIndexItem, AuditIndexPagination } from "@/types";

type IndexProps = {
  audits: AuditIndexItem[];
  pagination: AuditIndexPagination;
};

export default function Index({ audits, pagination }: IndexProps) {
  return (
    <Layout title="All audits">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="mb-1 text-2xl font-semibold">All audits</h1>
          <p className="text-gray-500">Historical evaluation runs for your domains</p>
        </div>
        <Link href="/audits/new" className="btn btn-primary shrink-0">
          Run page audit
        </Link>
      </div>

      {audits.length === 0 ? (
        <AuditsEmptyState />
      ) : (
        <>
          <AuditsList audits={audits} />

          {pagination.total_pages > 1 && <AuditsPagination pagination={pagination} />}
        </>
      )}
    </Layout>
  );
}
